export { default as ClipboardListSolidIcon } from './ClipboardListSolidIcon';
